const initialState = {
  transporters: [],
  transporter: null,
  loading: false,
  transporterLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
};

const transporterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_TRANSPORTERS_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_TRANSPORTERS_SUCCESS":
      return {
        ...state,
        loading: false,
        transporters: payload.data,
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_TRANSPORTERS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        transporters: [...state.transporters, ...payload.data],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_TRANSPORTERS_ERROR":
      return { ...state, loading: false, error: payload };

    case "FETCH_TRANSPORTER_LOADING":
      return { ...state, transporterLoading: true, error: null };

    case "FETCH_TRANSPORTER_SUCCESS":
      return { ...state, transporterLoading: false, transporter: payload, error: null };

    case "FETCH_TRANSPORTER_ERROR":
      return { ...state, transporterLoading: false, error: payload };

    case "CREATE_TRANSPORTER_LOADING":
      return { ...state, createLoading: true, error: null };

    case "CREATE_TRANSPORTER_SUCCESS":
      return {
        ...state,
        createLoading: false,
        transporters: [...state.transporters, payload],
        transporter: payload,
        error: null,
      };

    case "CREATE_TRANSPORTER_ERROR":
      return { ...state, createLoading: false, error: payload };

    case "UPDATE_TRANSPORTER_LOADING":
      return { ...state, updateLoading: true, error: null };

    case "UPDATE_TRANSPORTER_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        transporters: state.transporters.map((transporter) =>
          transporter.id === payload.id ? payload : transporter
        ),
        transporter: state.transporter?.id === payload.id ? payload : state.transporter,
        error: null,
      };

    case "UPDATE_TRANSPORTER_ERROR":
      return { ...state, updateLoading: false, error: payload };

    case "DELETE_TRANSPORTER_LOADING":
      return { ...state, deleteLoading: true, error: null };

    case "DELETE_TRANSPORTER_SUCCESS":
      return {
        ...state,
        deleteLoading: false,
        transporters: state.transporters.filter((transporter) => transporter.id !== payload),
        transporter: state.transporter?.id === payload ? null : state.transporter,
        error: null,
      };

    case "DELETE_TRANSPORTER_ERROR":
      return { ...state, deleteLoading: false, error: payload };

    case "REFETCH_TRANSPORTER_SUCCESS": {
      return {
        ...state,
        transporters: state.transporters.map((transporter) =>
          transporter.id === payload.id ? payload : transporter
        ),
        transporter: state.transporter?.id === payload.id ? payload : state.transporter,
      };
    }

    case "CLEAR_TRANSPORTER_DATA":
      return {
        ...state,
        transporter: null,
        error: null,
      };

    default:
      return state;
  }
};

export default transporterReducer;
